import { Box, styled, Tooltip } from '@mui/material';
import { IconQuestion } from 'assets/img';
import { FormSwitch } from 'redesign';
import { SettingSwitchProps } from './setting-switch.types';

export const SettingSwitch = ({
  control,
  name,
  label,
  tooltipDescription,
  iconTestId,
  disabled,
}: SettingSwitchProps) => {
  return (
    <TooltipContainer>
      <FormSwitch name={name} control={control} label={label} disabled={disabled} />
      {tooltipDescription ? (
        <Tooltip placement="bottom" title={tooltipDescription}>
          <IconWrapper>
            <IconQuestion data-testid={iconTestId} />
          </IconWrapper>
        </Tooltip>
      ) : null}
    </TooltipContainer>
  );
};

const TooltipContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(3),
}));

const IconWrapper = styled('span')(() => ({
  display: 'inline-flex',
  cursor: 'pointer',
  width: '20px',
  height: '20px',
}));
